/* eslint fp/no-mutation: 0, fp/no-this: 0, fp/no-mutating-methods: 0 */
import { fabric } from "fabric";

fabric.StaticCanvas.prototype.sortObjects = function (compare) {
  this._objects.sort(compare);
  this.requestRenderAll();
};
